import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

import { Button } from '../ui/catalyst/button';
import { Heading } from '../ui/catalyst/heading';
import { Text } from '../ui/catalyst/text';

interface DemandExamplesHeaderProps {
  onAddClick: () => void;
  isMultiSelect?: boolean;
  selectedCount?: number;
  onToggleMultiSelect?: (next: boolean) => void;
  onClearSelection?: () => void;
  onDeleteSelected?: () => void;
}

export const DemandExamplesHeader = ({
  onAddClick,
  isMultiSelect = false,
  selectedCount = 0,
  onToggleMultiSelect,
  onClearSelection,
  onDeleteSelected,
}: DemandExamplesHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <Heading level={1}>Demand Examples</Heading>
        <Text>Manage demand letter examples for your firm</Text>
      </div>
      <div className="flex items-center gap-2">
        <label
          className="flex items-center gap-2 mr-2"
          htmlFor="header-multi-select"
        >
          <input
            id="header-multi-select"
            type="checkbox"
            checked={isMultiSelect}
            onChange={(e) => onToggleMultiSelect?.(e.target.checked)}
          />
          <span className="text-sm">Multi-select</span>
        </label>
        {isMultiSelect && (
          <>
            <span className="text-sm text-zinc-600 mr-1">
              {selectedCount} selected
            </span>
            <Button
              plain
              onClick={onClearSelection}
              disabled={selectedCount === 0}
              className="text-sm"
            >
              Clear
            </Button>
            <Button
              onClick={onDeleteSelected}
              disabled={selectedCount === 0}
              className="bg-red-600 text-white hover:bg-red-700"
            >
              <TrashIcon className="h-4 w-4" />
              Delete selected
            </Button>
          </>
        )}
        <Button onClick={onAddClick}>
          <PlusIcon className="h-4 w-4" />
          Add Example
        </Button>
      </div>
    </div>
  );
};
